const Testimonials = () => {
  const reviews = [
    {
      name: 'Sarah Mitchell',
      location: 'Bristol, BS1',
      initials: 'SM',
      rating: 5,
      text: 'Absolutely brilliant service. Had a blocked drain at 11pm on a Sunday and they were at my door within 90 minutes. The maintenance plan has already paid for itself twice over. Wouldn\'t be without it.',
      plan: 'Monthly Plan Member',
    },
    {
      name: 'James Thornton',
      location: 'Southampton, SO14',
      initials: 'JT',
      rating: 5,
      text: 'As a landlord with 6 properties, the commercial plan is a no-brainer. One call, one invoice, everything sorted. My tenants are happy and I\'m not getting emergency calls at all hours anymore.',
      plan: 'Commercial Plan Member',
    },
    {
      name: 'Linda Pearce',
      location: 'Bournemouth, BH1',
      initials: 'LP',
      rating: 5,
      text: 'The annual CCTV survey found a root intrusion in my main drain that I had no idea about. Caught it early and saved me thousands. The plan literally paid for itself in the first year.',
      plan: 'All-In-One Plan Member',
    },
    {
      name: 'David Okafor',
      location: 'Wiltshire, SN1',
      initials: 'DO',
      rating: 5,
      text: 'Switched from another drainage company and the difference is night and day. Response times are incredible, engineers are professional and tidy, and the online portal makes everything so easy to manage.',
      plan: 'Monthly Plan Member',
    },
    {
      name: 'Rachel Summers',
      location: 'Dorset, DT1',
      initials: 'RS',
      rating: 5,
      text: 'I was sceptical about paying a monthly fee but after my first callout — which would have cost me £300+ without the plan — I was completely converted. Fantastic value and brilliant people.',
      plan: 'Monthly Plan Member',
    },
    {
      name: 'Tom Whitfield',
      location: 'Hampshire, PO1',
      initials: 'TW',
      rating: 5,
      text: 'Three years on the plan now and I\'ve had nothing but excellent service. The engineers always explain what they\'re doing, leave everything clean, and the reports they send are really thorough.',
      plan: 'All-In-One Plan Member',
    },
  ];

  return (
    <section id="testimonials" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
          <div>
            <span className="text-orange-500 text-xs font-bold uppercase tracking-widest">Trusted By 500+ Properties</span>
            <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mt-3 leading-tight">
              Real Protection Stories<br />
              <span className="text-gray-400">From Real Customers</span>
            </h2>
          </div>
          <div className="flex items-center gap-4 flex-shrink-0">
            <div className="text-center">
              <div className="text-4xl font-extrabold text-gray-900">4.9</div>
              <div className="flex gap-0.5 justify-center mt-1">
                {[1,2,3,4,5].map(i => (
                  <i key={i} className="ri-star-fill text-orange-400 text-sm"></i>
                ))}
              </div>
              <div className="text-gray-400 text-xs mt-1">Average Rating</div>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-4xl font-extrabold text-gray-900">500+</div>
              <div className="text-gray-400 text-xs mt-2">Verified Reviews</div>
            </div>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review) => (
            <div
              key={review.name}
              className="bg-white rounded-2xl p-6 flex flex-col gap-4 border border-gray-100 hover:border-orange-200 transition-colors"
            >
              {/* Stars */}
              <div className="flex gap-0.5">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-400 text-sm"></i>
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-600 text-sm leading-relaxed flex-1">
                &ldquo;{review.text}&rdquo;
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-2 border-t border-gray-50">
                <div className="w-10 h-10 flex items-center justify-center bg-orange-100 rounded-full flex-shrink-0">
                  <span className="text-orange-600 font-bold text-sm">{review.initials}</span>
                </div>
                <div>
                  <div className="text-gray-900 font-semibold text-sm">{review.name}</div>
                  <div className="text-gray-400 text-xs">{review.location}</div>
                </div>
                <div className="ml-auto">
                  <span className="bg-orange-50 text-orange-600 text-xs font-medium px-2 py-1 rounded-full whitespace-nowrap">
                    {review.plan}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Checkatrade badge area */}
        <div className="mt-12">
          <div className="flex flex-wrap justify-center items-center gap-4 mb-6">
            <div className="flex items-center gap-2 bg-white border border-gray-100 rounded-xl px-5 py-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-verified-badge-line text-orange-500 text-xl"></i>
              </div>
              <span className="text-gray-700 font-semibold text-sm">Checkatrade Approved</span>
            </div>
            <div className="flex items-center gap-2 bg-white border border-gray-100 rounded-xl px-5 py-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-shield-check-line text-orange-500 text-xl"></i>
              </div>
              <span className="text-gray-700 font-semibold text-sm">Public Liability Insured</span>
            </div>
            <div className="flex items-center gap-2 bg-white border border-gray-100 rounded-xl px-5 py-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-award-line text-orange-500 text-xl"></i>
              </div>
              <span className="text-gray-700 font-semibold text-sm">15+ Years Experience</span>
            </div>
            <div className="flex items-center gap-2 bg-white border border-gray-100 rounded-xl px-5 py-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-user-star-line text-orange-500 text-xl"></i>
              </div>
              <span className="text-gray-700 font-semibold text-sm">Trusted by 500+ Homeowners</span>
            </div>
            <div className="flex items-center gap-2 bg-white border border-gray-100 rounded-xl px-5 py-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-tools-line text-orange-500 text-xl"></i>
              </div>
              <span className="text-gray-700 font-semibold text-sm">NADC Member Engineers</span>
            </div>
            <div className="flex items-center gap-2 bg-white border border-gray-100 rounded-xl px-5 py-3">
              <div className="w-6 h-6 flex items-center justify-center">
                <i className="ri-building-line text-orange-500 text-xl"></i>
              </div>
              <span className="text-gray-700 font-semibold text-sm">Registered in England &amp; Wales</span>
            </div>
          </div>
          <p className="text-center text-gray-400 text-xs">
            All engineers are DBS checked, fully qualified, and carry comprehensive public liability insurance.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
